import React, { useContext, useState, useEffect } from 'react';
import styles from './style.module.scss';
import { Grid, Paper, Button, Table, TableContainer, TableHead, TableCell, TableBody, TableRow } from '@material-ui/core';
import { Context as AuthContext } from '../../context/AuthContext';
import { getCustomerData, signleCustomerUpload, uploadCustomerData } from './indexApi';
import UplaodFileModal from './uploadFileModal';
import AlertComponent from '../../components/AlertComponent';
import { ProductLoader } from '../../components/Loader/skeletonLoader';
import AddCustomerModal from './addCustomerDetails';

const CustomerData = () => {
    const { state } = useContext(AuthContext);
    const loginData = state.userData;
    const [customerData, setCustomerData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showAddCustModal, setShowAddCustModal] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertObj, setAlertObj] = useState({
        msg: null,
        color: null
    })
    const [pageLoader, setPageLoader] = useState(false);
    const errorColor = '#f44336';
    const successColor = '#4caf50';
    const [uploadLoader, setUploadLoader] = useState(false);
    const [addUploadLoader, setAddUploadLoader] = useState(false);
    const [addCustomerObj,setAddCustomerObj] = useState({
        customerName:null,
        mobile:null
    })


    useEffect(() => {
        fetchCustomerDetails();
    }, []);

    //function to fetch customer details
    const fetchCustomerDetails = async () => {
        setPageLoader(true);
        await getCustomerData().then((res) => {
            if (res && res.data && res.data.status === 'success') {
                setCustomerData(res.data.data);
            }
        })
        setPageLoader(false);
    }

    //function to fetch customer details
    const uploadCustomerFile = async (file) => {
        setUploadLoader(true);
        const formdata = new FormData();
        formdata.append('file', file);
        // formdata.append('sellerId', loginData.seller_id)
        await uploadCustomerData(formdata).then((res) => {
            if (res && res.data && res.data.status === 'success') {
                let msg = `Customer details uploaded successfully!!.`
                setAlertFnc(msg, successColor, true);
                setShowModal(false);
                fetchCustomerDetails();
            }
            else {
                setAlertFnc(res.data.msg, errorColor, true);
            }
        })
        setUploadLoader(false);
    }

    //function to show alerts
    const setAlertFnc = (msg, type, show) => {
        setShowAlert(show);
        setAlertObj({ msg: msg, color: type })
    }

    const handleCustomerInput = (e) => {
        setAddCustomerObj({...addCustomerObj,[e.target.name]:e.target.value})
    }

     //function to fetch customer details
     const addCustomerInfo = async () => {
        setAddUploadLoader(true);
        let obj = {
            name:addCustomerObj.customerName,
            phoneNumber:addCustomerObj.mobile
        }
        await signleCustomerUpload(obj).then((res) => {
            if (res && res.data && res.data.status === 'success') {
                let msg = `Customer detail added successfully!!.`
                setAlertFnc(msg, successColor, true);
                setShowAddCustModal(false);
                fetchCustomerDetails();
            }
            else {
                setAlertFnc(res.data.msg, errorColor, true);
            }
        })
        setAddUploadLoader(false);
    }

    return <div className={styles.mainContainer}>
        <h5>Customer Details</h5>
        < AlertComponent color={alertObj.color} msg={alertObj.msg} open={showAlert} handleClose={() => setShowAlert(false)} />
        <div className="mt-3 mb-3 ml-2">
            <Button variant="contained" className="mr-4" color="primary" onClick={() => {setShowAddCustModal(true);setAddCustomerObj({customerName:null,mobile:null})}}>Add Customer</Button>
            <Button variant="contained" color="primary" onClick={() => setShowModal(true)}>Bulk Upload</Button>
        </div>
        <Grid container spacing={3} id={styles.parentContainer}>
            <Grid item md={6} className={!pageLoader ? 'pl-0' : null}>
                {
                    pageLoader ?
                        <Paper className={styles.loaderWrapper}>
                            <div id={styles.headerLoader}>
                            </div>
                            <div className="pl-4 pr-4">
                                <ProductLoader />
                            </div>
                        </Paper>
                        :
                        <Paper className={styles.wrapper} elevation={2}>
                            {
                                customerData.length > 0 ?
                                    <TableContainer className={styles.parentWrapper}>
                                        <Table stickyHeader aria-label="sticky table"  >
                                            <TableHead>
                                                <TableRow >
                                                    <TableCell >
                                                        Customer Name
                                                    </TableCell>
                                                    <TableCell >
                                                        Phone Number
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody >
                                                {
                                                    customerData.map((item, index) => {
                                                        return <TableRow key={index}>
                                                            <TableCell >
                                                                {
                                                                    item.name
                                                                }
                                                            </TableCell>
                                                            <TableCell >
                                                                {
                                                                    item.phoneNumber
                                                                }
                                                            </TableCell>
                                                        </TableRow>
                                                    })
                                                }
                                            </TableBody >
                                        </Table>
                                    </TableContainer>
                                    :
                                    <div className="d-flex justify-content-center p-5 text-muted" style={{ fontSize: '0.875rem' }}>
                                        No customers data found!
                                    </div>
                            }
                        </Paper>
                }
            </Grid>
        </Grid>

        <UplaodFileModal
            show={showModal}
            handleClose={() => setShowModal(false)}
            uploadCustomerFile={uploadCustomerFile}
            uploadLoader={uploadLoader}
        />
        <AddCustomerModal
            show={showAddCustModal}
            handleClose={() => setShowAddCustModal(false)}
            addUploadLoader={addUploadLoader}
            addCustomerObj = {addCustomerObj}
            handleCustomerInput = {handleCustomerInput}
            addCustomerInfo = {addCustomerInfo}
        />
    </div>
}

export default CustomerData;